export default ":host {\n  display: grid;\n  justify-items: center;\n}";